import {
  CLEAR_CURRENCY_TRANSFERS,
  GET_TRANSACTIONS_LIST,
  SET_CURRENCY_INFO,
  SET_CURRENCY_TRANSFERS,
} from './constants';
import { TransactionsActions, TransactionsReducer } from './types';

const initState: TransactionsReducer = {
  transactions: [],
  currencyInfo: null,
  currencyTransfers: null,
  currencyTransfersUpdated: null,
  transactionsListUpdated: null,
};

export default (state = initState, action: TransactionsActions): TransactionsReducer => {
  switch (action.type) {
    case GET_TRANSACTIONS_LIST:
      return {
        ...state,
        transactions: action.payload.list,
        transactionsListUpdated: action.payload.time,
      };
    case SET_CURRENCY_INFO:
      return {
        ...state,
        currencyInfo: action.payload.currency,
      };
    case SET_CURRENCY_TRANSFERS:
      return {
        ...state,
        currencyTransfers: action.payload.list,
        currencyTransfersUpdated: action.payload.time,
      };
    case CLEAR_CURRENCY_TRANSFERS:
      return {
        ...state,
        currencyTransfers: null,
      };
    default:
      return state;
  }
};
